import styled from 'styled-components'

export const SiteNetworkMapWrapper = styled.div`
  width: 100%;
  height: 500px;
`
